import { createFileRoute, Outlet } from '@tanstack/react-router';
import { OwnerOnly } from '@/lib/auth/OwnerOnly';

/**
 * Layout route for `/listings/*` — `listings.$id.edit.tsx` (and this task's
 * new `listings.$id.ical.tsx`) sit alongside this file, which makes
 * TanStack Router treat this file as the PARENT of `/listings/$id/edit` (see
 * `bookings.tsx`'s comment for the full explanation of the flat file-route
 * pitfall; task 13's fix note flagged this exact file as having the
 * identical shape). The list UI lives in `listings.index.tsx`
 * (`/listings/`). `OwnerOnly` guards the whole subtree here rather than in
 * each leaf, since NOTHING under `/listings` is for reception (brief: nav
 * filtering hides the link, but a reception account typing the URL directly
 * must be refused, not shown the owner UI).
 */
export const Route = createFileRoute('/listings')({
  component: ListingsLayout,
});

function ListingsLayout() {
  return (
    <OwnerOnly>
      <Outlet />
    </OwnerOnly>
  );
}
